module.exports = new __parcel__URL__("kitten1.3f12ee9b.png").toString();